import ReshuffleTeamsModal from './ReshuffleTeamsModal';

export default ReshuffleTeamsModal;
